var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box, Dialog, DialogContent, DialogTitle, Paper, Tab, Tabs } from '@material-ui/core';
import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { fetchAdditionalFlights, fetchExternalFlight } from '../../../../../include/api-ito/ToursApi';
import { _T } from '../../../../../include/appI18n';
import { useFlightConfiguration, useTourDescription, useTourVariant } from '../../../store/TourDescriptionStore';
import AsyncSpinner from '../AsyncSpinner';
import { FlightAltVariant } from './FlightAltVariant';
import { FlightDetailsOneWay } from './FlightResultCard';
function TabPanel(props) {
    const { children, value, index } = props, other = __rest(props, ["children", "value", "index"]);
    return (React.createElement("div", Object.assign({ role: "tabpanel", hidden: value !== index, id: `scrollable-prevent-tabpanel-${index}`, "aria-labelledby": `scrollable-prevent-tab-${index}` }, other), value === index && (React.createElement(Box, { p: 0 }, children))));
}
export function AllFlightTariffDialog({ flights, current, onFlightSelect, onClose, dialogRef, isFrame }) {
    if (!flights.find(f => f.externalId && f.externalProviderId))
        throw new Error('В списке услуг отсутствуют актуальные внешние перелеты');
    const [currentTab, sertCurrentTab] = useState(flights.findIndex(f => f.externalId && f.externalProviderId));
    const groupedFlights = useMemo(() => Object.values(_.groupBy(flights, f => f.externalId)).map(f => ({ main: f[0], other: f.slice(1) })), flights);
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, { disableTypography: true },
            React.createElement("div", { className: "custom-modal-content-title" },
                React.createElement("div", { className: "title" }, _T.FLIGHT_SEARCH_TRANSPORT_SELECTION),
                React.createElement("div", { className: "dismisser", "data-dismiss": "modal", onClick: onClose }, "\u00D7")),
            React.createElement(Tabs, { value: currentTab, onChange: (e, s) => sertCurrentTab(s) }, groupedFlights.map((s, i) => (React.createElement(Tab, { value: i, label: React.createElement(React.Fragment, null,
                    React.createElement("div", null,
                        s.main.name,
                        s.other.length > 0 ? `, ${s.other.map(o => o.name).join(', ')}` : ''),
                    moment(s.main.beginDate).format('L'),
                    !s.main.externalId || !s.main.externalProviderId ? React.createElement("div", { className: "text-grey" }, "\u0412\u044B\u0431\u043E\u0440 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D") : null), disabled: !s.main.externalId || !s.main.externalProviderId }))))),
        React.createElement(DialogContent, { style: { padding: '0 !important' } }, groupedFlights.map((s, i) => {
            var _a;
            return (React.createElement(TabPanel, { value: currentTab, index: i, className: "flight-result" }, s.main.externalId && s.main.externalProviderId ? React.createElement(FlightTariffDialog, { onFlightSelect: f => onFlightSelect(s.main, f, s.other), current: (_a = current.find(c => c.service.serviceId == s.main.serviceId)) === null || _a === void 0 ? void 0 : _a.flight, isFrame: isFrame, service: s.main, key: i }) : React.createElement(React.Fragment, null)));
        }))));
}
export function FlightTariffDialog({ service, current, onFlightSelect, isFrame }) {
    var _a;
    if (!service.externalId || service.externalProviderId <= 0)
        throw new Error('Услуга не является актуальным внешним перелетом');
    const [{ tourVariant }] = useTourVariant(isFrame);
    const [{ flightConfiguration }] = useFlightConfiguration(isFrame);
    const [{ hash, price: tourPrice, separaretedSelectedExternalFlights, flightsLoading, tourDescription }, { setFlightForService }] = useTourDescription(null, isFrame);
    const [initialized, setInitialized] = useState(false);
    const [group, setGroup] = useState();
    const [selectedPrice, setSelectedPrice] = useState(current);
    const [additionalVariantsState, setAdditionalVariantsState] = useState('none');
    const [additionalVariants, setAdditionalVariants] = useState([]);
    const additionalVariantPrices = useMemo(() => additionalVariants.map(p => (Object.assign(Object.assign({}, p), { isCurrent: (selectedPrice === null || selectedPrice === void 0 ? void 0 : selectedPrice.flightId) == p.flightId }))), [selectedPrice, additionalVariants, group === null || group === void 0 ? void 0 : group.groupHash]);
    const [moreDetailedContent, setMoreDetailedContent] = useState();
    useEffect(() => {
        setAdditionalVariantsState('loading');
        (() => __awaiter(this, void 0, void 0, function* () {
            var _a;
            //вытяеуть с сервера
            const original = separaretedSelectedExternalFlights.find(f => f.serviceId == service.serviceId);
            const p1 = fetchExternalFlight(hash, { flightId: service.externalId, providerId: service.externalProviderId, serviceId: service.serviceId });
            //const p1 = fetchExternalFlight(hash!, { flightId: original?.flightId || service.externalId, providerId: original?.flightProviderId || service.externalProviderId });
            const p2 = fetchAdditionalFlights(hash, { flightId: service.externalId, providerId: service.externalProviderId, serviceId: service.serviceId });
            const [r1, r2] = yield Promise.all([p1, p2]);
            if ('errors' in r1) {
                console.error(`Couldn't load flight`);
                console.error(r1);
                return;
            }
            if ('errors' in r2) {
                console.error(`Couldn't load additional flights`);
                console.error(r2);
                return;
            }
            if (!selectedPrice)
                setSelectedPrice(r1);
            let v = _.orderBy(_.unionBy([...r2.prices, r1], r => r.flightId), r => r.flightCostDifference);
            setGroup({
                groupHash: service.serviceId.toFixed(),
                forwardFlightDuration: r1.forwardFlightDuration,
                forwardStops: [...r1.forwardStops.map(s => (Object.assign({}, s)))],
                prices: v,
                providerId: service.externalProviderId,
                selectedPrice: (_a = original === null || original === void 0 ? void 0 : original.flight) !== null && _a !== void 0 ? _a : r1,
                returnFlightDuration: 0,
                returnStops: []
            });
            setAdditionalVariants(v);
            setAdditionalVariantsState('loaded');
        }))();
    }, [hash]);
    const FlightDetailsMoreVariants = () => (React.createElement("div", { className: "details" },
        React.createElement(Paper, { elevation: 2, className: "additional-variants" }, additionalVariantsState == 'loaded' && additionalVariants.length > 0 ?
            React.createElement("div", { className: "alt-variants-grid" }, additionalVariantPrices.map((v, i) => React.createElement(FlightAltVariant, { group: group, variant: v, isCurrent: v.isCurrent, currentInGroup: selectedPrice, isFrame: isFrame, onSelect: (s) => {
                    setSelectedPrice(s);
                    onFlightSelect(s);
                }, key: i, onAltMoreDetailed: setMoreDetailedContent }))) :
            React.createElement("div", { className: "text-center py-3" }, additionalVariantsState == 'loading' || additionalVariantsState == 'none' ?
                React.createElement("span", { className: "fa fa-spinner fa-spin fa-2x" }) :
                React.createElement(React.Fragment, null, _T.FLIGHT_SEARCH_ADDITIONAL_VARIANTS_LOADING_FAILED)))));
    return (React.createElement(React.Fragment, null,
        tourVariant ?
            React.createElement(React.Fragment, null, group && selectedPrice
                ? React.createElement(React.Fragment, null,
                    React.createElement(FlightDetailsMoreVariants, null),
                    React.createElement(Box, { p: 2 },
                        React.createElement(FlightDetailsOneWay, { direction: "forward", selectedPrice: selectedPrice }),
                        ((_a = selectedPrice.returnStops) === null || _a === void 0 ? void 0 : _a.length) ? React.createElement(FlightDetailsOneWay, { direction: "return", selectedPrice: selectedPrice }) : null))
                : React.createElement(AsyncSpinner, null)) : null,
        React.createElement(Dialog, { id: "flight-provider-details-ui", maxWidth: "xl", open: !!moreDetailedContent, onClose: () => setMoreDetailedContent(undefined) },
            React.createElement(DialogContent, { className: "modal-content custom-modal-content" }, moreDetailedContent))));
}
export function FlightTariffDialog2({ flights, current, onFlightSelect, onClose, dialogRef, isFrame }) {
    var _a;
    const [{ tourVariant }] = useTourVariant(isFrame);
    const [{ flightConfiguration }] = useFlightConfiguration(isFrame);
    const [{ hash, price: tourPrice, externalFlight, flightsLoading, tourDescription }, { setFlightForService }] = useTourDescription(null, isFrame);
    const [initialized, setInitialized] = useState(false);
    const [group, setGroup] = useState();
    const [selectedPrice, setSelectedPrice] = useState(current);
    const [additionalVariantsState, setAdditionalVariantsState] = useState('none');
    const [additionalVariants, setAdditionalVariants] = useState([]);
    const additionalVariantPrices = useMemo(() => additionalVariants.map(p => (Object.assign(Object.assign({}, p), { isCurrent: (selectedPrice === null || selectedPrice === void 0 ? void 0 : selectedPrice.flightId) == p.flightId }))), [selectedPrice, additionalVariants, group === null || group === void 0 ? void 0 : group.groupHash]);
    const [moreDetailedContent, setMoreDetailedContent] = useState();
    useEffect(() => {
        setAdditionalVariantsState('loading');
        (() => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            //вытяеуть с сервера
            const p1 = fetchExternalFlight(hash, { flightId: flights[0].externalId, providerId: flights[0].externalProviderId });
            const p2 = fetchAdditionalFlights(hash, { flightId: flights[0].externalId, providerId: flights[0].externalProviderId });
            const [r1, r2] = yield Promise.all([p1, p2]);
            if ('errors' in r1) {
                console.error(`Couldn't load flight`);
                console.error(r1);
                return;
            }
            if ('errors' in r2) {
                console.error(`Couldn't load additional flights`);
                console.error(r2);
                return;
            }
            if (!selectedPrice)
                setSelectedPrice(r1);
            let v = _.orderBy(_.unionBy([...r2.prices, r1], r => r.flightId), r => r.flightCostDifference);
            setGroup({
                groupHash: flights[0].serviceId.toFixed(),
                forwardFlightDuration: r1.forwardFlightDuration,
                forwardStops: [...r1.forwardStops.map(s => (Object.assign({}, s)))],
                returnFlightDuration: r1.returnFlightDuration,
                returnStops: [...(_b = (_a = r1.returnStops) === null || _a === void 0 ? void 0 : _a.map(s => (Object.assign({}, s)))) !== null && _b !== void 0 ? _b : []],
                prices: v,
                providerId: flights[0].externalProviderId,
                selectedPrice: r1,
            });
            setAdditionalVariants(v);
            setAdditionalVariantsState('loaded');
        }))();
    }, [hash]);
    const FlightDetailsMoreVariants = () => (React.createElement("div", { className: "details" },
        React.createElement(Paper, { elevation: 2, className: "additional-variants" }, additionalVariantsState == 'loaded' && additionalVariants.length > 0 ?
            React.createElement("div", { className: "alt-variants-grid" }, additionalVariantPrices.map((v, i) => React.createElement(FlightAltVariant, { group: group, variant: v, isCurrent: v.isCurrent, currentInGroup: selectedPrice, isFrame: isFrame, onSelect: (s) => {
                    setSelectedPrice(s);
                    onFlightSelect(s);
                }, key: i, onAltMoreDetailed: setMoreDetailedContent }))) :
            React.createElement("div", { className: "text-center py-3" }, additionalVariantsState == 'loading' || additionalVariantsState == 'none' ?
                React.createElement("span", { className: "fa fa-spinner fa-spin fa-2x" }) :
                React.createElement(React.Fragment, null, _T.FLIGHT_SEARCH_ADDITIONAL_VARIANTS_LOADING_FAILED)))));
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, { disableTypography: true },
            React.createElement("div", { className: "custom-modal-content-title" },
                React.createElement("div", { className: "title" }, _T.FLIGHT_SEARCH_TRANSPORT_SELECTION),
                React.createElement("div", { className: "dismisser", "data-dismiss": "modal", onClick: onClose }, "\u00D7"))),
        React.createElement(DialogContent, { style: { padding: '0 !important' }, className: "flight-result" }, tourVariant ?
            React.createElement(React.Fragment, null, group && selectedPrice
                ? React.createElement(React.Fragment, null,
                    React.createElement(FlightDetailsMoreVariants, null),
                    React.createElement(Box, { p: 2 },
                        React.createElement(FlightDetailsOneWay, { direction: "forward", selectedPrice: selectedPrice }),
                        ((_a = selectedPrice.returnStops) === null || _a === void 0 ? void 0 : _a.length) ? React.createElement(FlightDetailsOneWay, { direction: "return", selectedPrice: selectedPrice }) : null))
                : React.createElement(AsyncSpinner, null)) : null),
        React.createElement(Dialog, { id: "flight-provider-details-ui", maxWidth: "xl", open: !!moreDetailedContent, onClose: () => setMoreDetailedContent(undefined) },
            React.createElement(DialogContent, { className: "modal-content custom-modal-content" }, moreDetailedContent))));
}
